import { METRICS_MAP } from '../constants';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { urlConcatParams } from '@intelligence/utils/urlConcatParams';

export const MOBILE_CONFIG: any = {
  common: {
    keyMap: {
      // 排名
      id: 'id',
      // 英文名称，可以是游戏名称、公司名称、国家名称等，根据firstCol的type配置来显示
      gametitle: 'marketEn',
      // 中文名称，同上
      gametitleCn: 'marketCn',
      // 颜色排名映射字段，表格第一列checkbox的颜色
      colorRank: 'colorRank',
      abbr: 'abbr',
      // 国家图标，会根据国家缩写进行自动匹配
      countryIcon: 'country_img',
      imgType: 'imgType',
      textBubble: 'big_riser_tips',
      // 右键跳转用
      linkUrl: 'linkUrl',
      // 指标列的数据字段
      metricList: 'metric_list',
      // 指标列的各项配置
      metricTitle: 'title',
      metricSource: 'source',
      metricName: 'metric',
      metricRatio: 'value_ratio',
      metricValue: 'value',
    },
    getTrueKey: (sortKey: string) => {
      const len = sortKey.length;
      return {
        trueKey: sortKey.slice(0, len - 2),
        sortType: sortKey.slice(len - 1),
      };
    },
    sortFn: (_list, sortKey: string, sortOrder, noRank: boolean) => {
      const { trueKey, sortType } = that.common.getTrueKey(sortKey);
      const { keyMap } = that.common;
      const findMetric = (metricList, key: string, typeStr: 'value' | 'value_ratio') => {
        const find = metricList?.find((item) => item.metric === key);
        if (find) return find[typeStr] || 0;
        return 0;
      };
      // 对比方法
      const compareFun = (a: any, b: any) => {
        const typeStr = sortType === '0' ? keyMap.metricValue : keyMap.metricRatio;
        const metricListName = keyMap.metricList;
        const aValue = findMetric(a[metricListName], trueKey, typeStr);
        const bValue = findMetric(b[metricListName], trueKey, typeStr);
        return sortOrder === 'desc' ? bValue - aValue : aValue - bValue;
      };

      return _list.sort(compareFun)?.map((item, index) =>
        Object.assign(item, {
          id: noRank ? null : index + 1,
        }),
      );
    },
    getLinkUrl: ({
      marketName,
      marketAbbr,
      pageId,
      source,
      isAnnie = '0',
    }: {
      marketName: string;
      marketAbbr: string;
      pageId: string;
      source: string;
      isAnnie?: string;
    }) => {
      // const url = `/intelligence/marketProfile/Overview/detail?marketName=${marketName}&marketNameEn=${marketAbbr}&pageId=${pageId}&isAnnie=0`;
      const rawParams = {
        marketName,
        marketNameEn: marketAbbr,
        pageId,
        source,
        isAnnie,
      };

      const params = new URLSearchParams(rawParams);
      // const params = urlConcatParams(rawParams);
      // const url = `/intelligence/MarketProfile/Overview/detail?${params}`;
      const url = `/intelligence/marketProfile/Overview/detail?${params}`;

      // console.log('url:', { url, params });
      return url;
    },
    getMetricConfig: (item, sortKey: string, sourceName) => {
      const { value_ratio: growth, metric, value } = item || {};
      return {
        align: 'center',
        value_ratio: growth,
        isNeedSort: metric === sortKey,
        metric: `${sourceName}_${metric}`,
        source: sourceName,
        title: METRICS_MAP[metric],
        value,
      };
    },
    getTargetCountryMap: (map: any[]) => {
      const tmpObj: Record<string, any> = {};
      map?.forEach((item) => {
        tmpObj[item.country_name_abbre.toLowerCase()] = item;
      });
      return tmpObj;
    },
    getEmptyMetricObj: (currentSource, metric) => ({
      value: '-',
      value_ratio: '-',
      metric,
      source: currentSource,
    }),
    tableDataFormatter: (fetchList = [], tableAction, currentSource, countryMap) => {
      const targetCountryMap = that.common.getTargetCountryMap(countryMap) || {};
      const { sortKey, sortOrder } = tableAction;
      const tmpObj: any = {};
      fetchList.forEach((item) => {
        const { market, metric, source } = item || {};
        if (!Object.prototype.hasOwnProperty.call(tmpObj, market)) {
          tmpObj[market] = {};
        }
        tmpObj[market][`${source}_${metric}`] = item;
      });
      const result = Object.keys(tmpObj).map((key) => {
        const tmpMetricObj = tmpObj[key];
        const tmpRevenue =
          tmpMetricObj[`${currentSource}_revenue`] ||
          that.common.getEmptyMetricObj(currentSource, 'revenue');
        const tmpDownload =
          tmpMetricObj[`${currentSource}_download`] ||
          that.common.getEmptyMetricObj(currentSource, 'download');
        const tmpArr = [
          that.common.getMetricConfig(tmpRevenue, sortKey, currentSource),
          that.common.getMetricConfig(tmpDownload, sortKey, currentSource),
        ];
        return {
          country_img: getCountryFlag(key),
          imgType: 'mobile',
          metric_list: tmpArr,
          market: targetCountryMap[key]?.country_name_en,
          marketEn: targetCountryMap[key]?.country_name_cn,
          abbr: key,
        };
      });
      return {
        original: result,
        formatted: that.common.sortFn(result, sortKey, sortOrder),
      };
    },
    lineChartDataFormatter: () => {},
  },
  mobile: {
    lineMetricList: [
      {
        label: 'dbi_revenue_$',
        key: 'annie_revenue',
      },
      {
        label: 'dbi_downloads',
        key: 'annie_download',
      },
    ],
    tableMetricList: [
      {
        title: 'dbi_revenue_$',
        source: 'appannie',
        metric: 'appannie_revenue',
        align: 'center',
        childWidth: 200,
        childAlign: 'right',
        isNeedSort: true,
        hideCond: 'sensortower',
      },
      {
        title: 'dbi_downloads',
        source: 'appannie',
        metric: 'appannie_download',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
        hideCond: 'sensortower',
      },
      // {
      //   title: 'dbi_market_total_game',
      //   source: 'appannie',
      //   metric: 'appannie_game_count',
      //   align: 'center',
      //   childWidth: 190,
      //   childAlign: 'right',
      //   isNeedSort: true,
      //   hideCond: 'sensortower,appannie',
      // },
      {
        title: 'dbi_revenue_$',
        source: 'sensortower',
        metric: 'sensortower_revenue',
        align: 'center',
        childWidth: 200,
        childAlign: 'right',
        isNeedSort: true,
        hideCond: 'appannie',
      },
      {
        title: 'dbi_downloads',
        source: 'sensortower',
        metric: 'sensortower_download',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
        hideCond: 'appannie',
      },
      // {
      //   title: 'dbi_market_total_game',
      //   source: 'sensortower',
      //   metric: 'sensortower_game_count',
      //   align: 'center',
      //   childWidth: 190,
      //   childAlign: 'right',
      //   isNeedSort: true,
      //   hideCond: 'sensortower,appannie',
      // },
    ],
    firstCol: [
      {
        title: 'dbi_market',
        type: 'region',
        key: 'market',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: true,
        canBeClick: true,
        width: 400,
      },
    ],
    specialCol: [
      {
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
        hideCond: 'global,global_wo_china,ww',
      },
    ],
    tableFormatter: (fetchList, sortKey, sourceName) =>
      that.common.tableDataFormatter(fetchList, sortKey, sourceName),
    lineFormatter: (params) => that.common.lineChartDataFormatter(params),
  },
};

const that = MOBILE_CONFIG;
